var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"training-group"},[_c('img',{attrs:{"src":"https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/assets/misc/px.jpg"}}),_c('div',{staticClass:"tg-mask"}),_c('div',{staticClass:"tg-name"},[_vm._v(" "+_vm._s(_vm.value.name)+" ")]),_c('div',{staticClass:"tg-count"},[_vm._v(" "+_vm._s(_vm.value.count || 0)+" 个课程 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }